import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LogoImg from './../../assets/img/logoW.png';

import { GiFarmer, GiCow } from 'react-icons/gi';
import { BsCloudSunFill, BsFileBarGraphFill, BsGearFill } from 'react-icons/bs';
import { FaHome, FaTractor, FaPowerOff, FaChartPie } from 'react-icons/fa';
import { GiTakeMyMoney } from "react-icons/gi";

import { Row, Col } from 'reactstrap';

function Header() {
    const [m1, setM1] = useState(false);
    const [m2, setM2] = useState(false);
    const [m3, setM3] = useState(false);
    const [m4, setM4] = useState(false);
    const [m5, setM5] = useState(false);
    const [m6, setM6] = useState(false);
    const [m7, setM7] = useState(false);
    const [role, setRole] = useState(null);
    const [logo, setLogo] = useState(null);

    useEffect(() => {
        let role = sessionStorage.getItem('role');
        setRole(role);
        // logo

        let logo = sessionStorage.getItem('logo');
        setLogo(logo);
        //
    }, []);

    return (
        <>
            <div className='headerPage borderBottom enhanced-header bg-primary'>
                <Row className="header-row align-items-center">
                    <Col xs={3}>
                        <div className="logo-container">
                            <img
                                className="logo-img ms-3"
                                style={{ maxHeight: "60px", maxWidth: "200px" }}
                                src={logo ?? LogoImg}
                                alt="logo"
                            />
                        </div>

                    </Col>
                    <Col xs={9}>
                        <div className='nav-container'>

                            <div className='w-menu'>
                                <Link className='linkMenu' to='/home'>
                                    <FaHome size={20} />
                                </Link>
                            </div>

                            <div className='w-menu' onMouseEnter={() => setM1(true)} onMouseLeave={() => setM1(false)}>
                                <GiFarmer size={20} />
                                {m1 &&
                                    <div>
                                        <div className='w-container'>
                                            <div className='menuHeader'>Farm Activities</div>
                                            <Link className='linkPage' to='/traceability'> Traceability </Link>
                                            <Link className='linkPage' to='/meeting'> Meeting </Link>
                                            <Link className='linkPage' to='/Training'> Training </Link>
                                            <Link className='linkPage' to='/distribution'> Distribution </Link>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className='w-menu' onMouseEnter={() => setM2(true)} onMouseLeave={() => setM2(false)}>
                                <GiCow size={25} />
                                {m2 &&
                                    <div>
                                        <div className='w-container'>
                                            <div className='menuHeader'>Livestock</div>
                                            <Link className='linkPage' to='/livestock-count'> Livestock Count </Link>
                                            <Link className='linkPage' to='/livestock-activity'> Livestock Activity </Link>
                                            <Link className='linkPage' to='/livestock-alert'> Livestock Alert </Link>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className='w-menu' onMouseEnter={() => setM4(true)} onMouseLeave={() => setM4(false)}>
                                <FaTractor size={20} />
                                {m4 &&
                                    <div>
                                        <div className='w-container'>
                                            <div className='menuHeader'>Master</div>
                                            <Link className='linkPage' to='/farmer'> Farmer </Link>
                                            {role === "1004" &&
                                                <>
                                                    <Link className='linkPage' to='/employee'> Employee </Link>
                                                    <Link className='linkPage' to='/user-management'> User Management </Link>
                                                    <Link className='linkPage' to='/crop-master'> Crop Master </Link>
                                                    <Link className='linkPage' to='/crop-variety'> Crop Variety </Link>
                                                </>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className='w-menu' onMouseEnter={() => setM5(true)} onMouseLeave={() => setM5(false)}>
                                <FaChartPie size={20} />
                                {m5 &&
                                    <div>
                                        <div className='w-container'>
                                            <div className='menuHeader'>Reports</div>
                                            <Link className='linkPage' to='/farmer-sowing-report'> Farmers Sowing Report </Link>
                                            <Link className='linkPage' to='/monthly-livestock-report'> Livestock Report (Monthly)</Link>
                                            <Link className='linkPage' to='/monthly-agriculture-report'> Agriculture Report (Monthly)</Link>
                                        </div>
                                    </div>
                                }
                            </div>

                            {role === "1004" &&
                                <>
                                    <div className='w-menu' onMouseEnter={() => setM6(true)} onMouseLeave={() => setM6(false)}>
                                        <GiTakeMyMoney size={20} />
                                        {m6 &&
                                            <div>
                                                <div className='w-container'>
                                                    <div className='menuHeader'>Accounting</div>
                                                    <Link className='linkPage' to='/balance-sheet'> Balance-Sheet </Link>
                                                    <Link className='linkPage' to='/charts-of-account'> Charts Of Account</Link>
                                                    <Link className='linkPage' to='/profit-loss'> Profit-Loss</Link>
                                                    <Link className='linkPage' to='/trial-balance'> Trial-Balance</Link>
                                                    <Link className='linkPage' to='/Payment'> Payment</Link>
                                                    <Link className='linkPage' to='/journal-list'> Journal List</Link>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div className='w-menu' onMouseEnter={() => setM7(true)} onMouseLeave={() => setM7(false)}>
                                        <BsGearFill size={20} />
                                        {m7 &&
                                            <div>
                                                <div className='w-container'>
                                                    <div className='menuHeader'>Setting</div>
                                                    <Link className='linkPage' to='/organisation'> Organisation </Link>
                                                    <Link className='linkPage' to='/pop'> POP (Package of practices) </Link>
                                                    <Link className='linkPage' to='/demand'> Demand </Link>
                                                    <Link className='linkPage' to='/input-sale-purchase'> Input-sale-purchase </Link>
                                                    <Link className='linkPage' to='/produce-sale-purchase'> Produce-sale-purchase </Link>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </>
                            }

                            <div className='w-menu logout-btn bg-danger'>
                                <Link className='linkMenu' to='/' onClick={() => sessionStorage.clear()}>
                                    <FaPowerOff size={20} />
                                </Link>
                            </div>

                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default Header;